import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import { IoArrowDown, IoArrowForward } from 'react-icons/io5';

const BEFORE = [
  { label: '郵送・メール・PDFで届く', sub: '各社バラバラのフォーマット' },
  { label: '学校が中身を確認' },
  { label: '紙をスキャン', sub: '複合機で一枚ずつ' },
  { label: 'PDF化・ファイル名を整える' },
  { label: '年度・企業ごとにファイリング', sub: 'Drive / 共有フォルダ / 紙の保管' },
  { label: '学生が見られる状態にして案内' },
];

const AFTER = [
  { label: 'サロンが Web で求人情報を入力' },
  { label: '学校の管理画面に届く', sub: '整理された一覧で' },
  { label: '学校が内容を確認' },
  { label: 'そのまま学生へ届ける' },
];

const Column = ({
  tag, steps, variant,
}: {
  tag: string;
  steps: { label: string; sub?: string }[];
  variant: 'before' | 'after';
}) => (
  <div className={`${Styles.col} ${variant === 'after' ? Styles.colAfter : Styles.colBefore}`}>
    <span className={Styles.tag}>{tag}</span>
    <ol className={Styles.steps}>
      {steps.map((s, i) => (
        <li key={s.label}>
          <div className={Styles.stepBody}>
            <span className={Styles.stepLabel}>{s.label}</span>
            {s.sub && <span className={Styles.stepSub}>{s.sub}</span>}
          </div>
          {i < steps.length - 1 && <IoArrowDown className={Styles.stepArrow} aria-hidden="true" />}
        </li>
      ))}
    </ol>
  </div>
);

const Shift = () => {
  return (
    <section id="shift" className={Styles.shift}>
      <SectionTitle
        pattern="B"
        title={<>求人票をデジタル化するのではなく、<br className={Styles.brsp} />最初からデジタルで受け取る</>}
        lead="「紙をデジタル化できます」だけなら、スキャナーや Google Drive でもできます。memorii works の本質は、学校がデジタル化する作業そのものが要らなくなることです。"
      />

      <div className={Styles.compare}>
        <Column tag="これまで" steps={BEFORE} variant="before" />
        <IoArrowForward className={Styles.bigArrow} aria-hidden="true" />
        <Column tag="memorii works" steps={AFTER} variant="after" />
      </div>

      <p className={Styles.punch}>
        今までは学校が求人票をデジタル化していた。<br />
        <strong>memorii works なら、最初からデジタルで届く。</strong>
      </p>
    </section>
  );
};

export default Shift;
